import cookieSet from './cookieSet';

const env = import.meta.env;

export const isLocalhost = cookieSet.currentStagingName.get() === 'localhost';
export const isDevelopment = !!env.DEV;
export const isProduction = !!env.VITE_IS_PRODUCTION;

export const localhostEndpoint = env.VITE_LOCAL_API;

export default {};
